import { BrandApi } from "@core/apis/core/brand.api";
export const CareerStoryPageManagerRoutes = [
    {
        "url": "/csb-manager",
        "name": "appLayout.harriSH.csp",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "abstract": true,
        "params": {},
        "component": "careerStoryPageManagerContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["career-story-page-manger"]
        },
        "onEnter": ['$state', '$stateParams', 'userPermissions', 'brandServices', async ($state, $stateParams, userPermissions, brandServices) => {
                let activeBrandId = $stateParams['brand_id'];
                let policyParser = await userPermissions.getBrandPolicy(activeBrandId);
                let canManageCareerStoryPagePermissions = policyParser.has(userPermissions.PERMISSIONS['MANAGE_CAREER_STORY_PAGE']);
                let isGroupCareerPortalServiceEnabled = await brandServices.check(brandServices.SERVICES.GROUP_CAREER_PORTAL, activeBrandId);
                let isCareerStoryPageEnabled = false;
                if (canManageCareerStoryPagePermissions && isGroupCareerPortalServiceEnabled) {
                    let careerStoryPageSettings = await BrandApi.getCareerStoryPageSettings(activeBrandId);
                    isCareerStoryPageEnabled = careerStoryPageSettings.enabled;
                }
                if (!canManageCareerStoryPagePermissions || !isGroupCareerPortalServiceEnabled || !isCareerStoryPageEnabled) {
                    $state.go("404");
                }
                if (isCareerStoryPageEnabled && !$stateParams['csp_id']) {
                    const cspResult = await BrandApi.getCSPs(activeBrandId);
                    const cspInfo = cspResult.career_story_pages;
                    if (cspInfo.length && cspInfo[0].id) {
                        $state.go('appLayout.harriSH.csp.create', { brand_id: activeBrandId, csp_id: cspInfo[0].id });
                    }
                }
            }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/career-story-page-manger/career-story-page-manger.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/create?brand_id&csp_id",
        "name": "appLayout.harriSH.csp.create",
        "type": "frontend",
        "loginRequired": true,
        "params": {
            brand_id: {
                dynamic: true
            },
        },
        "views": {
            'body': {
                'component': 'careerStoryPageManagerManageContainer'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["career-story-page-manger"]
        },
    },
];
//# sourceMappingURL=career-story-page-manger.routes.js.map